<template>
    <oc-page title="Change password" id="change-pass">
        <h4 class="section-title">Change Password</h4>
        <div class="hr mb-4" />

        <oc-form :model="form" @submit.native.prevent="change">
            <oc-row>
                <oc-col size="6">
                    <oc-form-field
                        target="password"
                        iconShowPassword="glyphicon glyphicon-eye-open"
                        iconHidePassword="glyphicon glyphicon-eye-close"
                        :inputPrepend="null"
                        theme="password"
                    />

                    <oc-form-field
                        target="newPassword"
                        iconShowPassword="glyphicon glyphicon-eye-open"
                        iconHidePassword="glyphicon glyphicon-eye-close"
                        :inputPrepend="null"
                        theme="password"
                    />

                    <oc-form-field
                        target="confirmNewPassword"
                        placeholderPrefix=""
                        iconShowPassword="glyphicon glyphicon-eye-open"
                        iconHidePassword="glyphicon glyphicon-eye-close"
                        :inputPrepend="null"
                        theme="password"
                    />

                    <div class="clearfix" />

                    <oc-submit-button-input class="mt-3 mb-3 btn btn-info" :disabled="form.validator().errors().any()">
                        <oc-icon type="pencil-square-o" />
                        Change
                    </oc-submit-button-input>
                </oc-col>
            </oc-row>
        </oc-form>
    </oc-page>
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'
import { Form } from '@framework'

export default {
    name: "change-pass",
    mixins: [AuthStateMixin],
    data() {
        return {
            form: new Form({
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            }, ($, rules) => {
                return rules(
                    $('*').required(false, {errorMessage: (target) => `Please enter a ${target.toLowerCase()}`}),
                    $('newPassword').not('equals', 'password', true),
                    $('confirmNewPassword').equals('newPassword', true)
                )
            }, {
                password: 'Current Password',
                newPassword: 'New Password',
                confirmNewPassword: 'Confirm New Password'
            })
        }
    },
    methods: {
        change() {
            this.form.validate().then( result => {
                if( ! result.valid ) {
                    return false
                }

                let formData = this.form.getData()

                API.POST('verify-password', null, {
                    password: formData.password
                }).then( response => {

                    if( ! response.success() ) {
                        this.form.addError('password', response.getMessage())
                        return
                    }

                    if( ! response.getData('verified') )
                    {
                        let remainingRetries = response.getData('maxLoginRetries') - response.getData('loginRetries')

                        if( remainingRetries === 0 )
                        {
                            return this.$root.logout()
                        }

                        this.form.addError('password', `The password is not correct. You have ${remainingRetries} remaining attempts.`)
                        return
                    }

                    if( this.form.validator().errors().any() ) {
                        return
                    }

                    API.POST('app', 'change-password', {
                        password: formData.newPassword
                    }).then( response => {
                        this.$addFlashMessage(response.getMessage(), 'success')
                        this.$addFlashMessage('You will be forced to re-login with your new password.', 'warning')
                        this.form.reset()

                        setTimeout(() => {
                            window.location.reload()
                            window._appRedirected = true // prevent the next router actions
                        }, 2000)
                    })

                }).catch(e => {
                    this.form.addError('password', 'Error while validating your current password.')
                })
            })
        }
    }
}
</script>
